export default "__VITE_ASSET__BmtmPevA__"